/* global fetch */
import * as NUMBER from 'constant/number'
import _ from 'lodash'
import url from 'url'
import * as CONTENT_TYPE from 'common/constant/content-type'
import * as HTTP_METHOD from 'common/constant/http-method'

const API_URL = process.env.API_URL

const createFormattedUrl = (apiUrl, query) => {
  const parsedUrl = url.parse(apiUrl) // eslint-disable-line
  const parsedAPIUrl = url.parse(API_URL) // eslint-disable-line

  const formattedUrl = url.format({
    ...parsedAPIUrl,
    ..._.pick(parsedUrl, ['href', 'path', 'pathname']),
    query: _.pickBy(query, _.identity)
  })

  return formattedUrl
}

// eslint-disable-next-line complexity
const parseResponse = (func, attempts, ...args) => async (response, returnHeaders, returnStatus = false) => {
  const json = await response.json()
  if (response.ok) {
    if (returnHeaders) {
      return response
    }
    if (returnStatus) {
      return { response: json, status: response.status }
    }
    return json
  } else {
    return handleResponseError(returnStatus, response, json)
  }
}

const handleResponseError = (returnStatus, response, json) => {
  if (returnStatus) {
    return { status: response.status }
  } else {
    throw new Error(json.error)
  }
}

export const postJson = (inputUrl, headers = {}, body = {}, returnHeaders = false) => {
  const attempts = NUMBER.ZERO

  return postJsonFetch(inputUrl, headers, body, returnHeaders, attempts)
}
export const postJsonFetch = async (inputUrl, headers = {}, body = {}, returnHeaders = false, attempts) => {
  attempts++
  try {
    const response = await fetch(createFormattedUrl(inputUrl, null), {
      body: typeof body === 'string' ? body : JSON.stringify(body),
      credentials: HTTP_METHOD.CREDENTIALS_INCLUDE,
      headers: {
        [CONTENT_TYPE.CONTENT_TYPE_HEADER]: CONTENT_TYPE.JSON,
        ...headers
      },
      method: HTTP_METHOD.POST
    })
    const parsed = await parseResponse(postJsonFetch, attempts, inputUrl, headers, body, returnHeaders)(response, returnHeaders)
    return parsed
  } catch (error) {
    if (attempts < NUMBER.FOUR) {
      return postJsonFetch(inputUrl, headers, body, returnHeaders, attempts)
    }

    return error
  }
}

export const getJson = (inputUrl, headers = {}, queryStrings = {}, returnStatus = false) => {
  const attempts = NUMBER.ZERO

  return getJsonFetch(inputUrl, headers, queryStrings, returnStatus, attempts)
}

export const getJsonFetch = async (inputUrl, headers = {}, queryStrings = {}, returnStatus = false, attempts) => {
  attempts++
  try {
    const response = await fetch(createFormattedUrl(inputUrl, queryStrings), {
      credentials: HTTP_METHOD.CREDENTIALS_INCLUDE,
      headers: {
        [CONTENT_TYPE.CONTENT_TYPE_HEADER]: CONTENT_TYPE.JSON,
        ...headers
      },
      method: HTTP_METHOD.GET
    })

    const parsed = await parseResponse(getJson, attempts, inputUrl, headers, queryStrings, returnStatus)(response, false, returnStatus)
    return parsed
  } catch (error) {
    if (attempts < NUMBER.FOUR) {
      return getJsonFetch(inputUrl, headers, queryStrings, returnStatus, attempts)
    }
    return error
  }
}

export const putFile = async (inputUrl, file, contentType, headers = {}) => {
  const response = await fetch(inputUrl, {
    body: file,
    headers: {
      [CONTENT_TYPE.CONTENT_TYPE_HEADER]: contentType,
      ...headers
    },
    method: HTTP_METHOD.PUT
  })

  return response
}

export const getFile = async (inputUrl) => {
  const response = await fetch(inputUrl, {
    method: HTTP_METHOD.GET
  })

  return response.text()
}

export const deleteJson = async (inputUrl, headers = {}, queryStrings = {}) => {
  const response = await fetch(createFormattedUrl(inputUrl, queryStrings), {
    credentials: HTTP_METHOD.CREDENTIALS_INCLUDE,
    headers: {
      [CONTENT_TYPE.CONTENT_TYPE_HEADER]: CONTENT_TYPE,
      ...headers
    },
    method: HTTP_METHOD.DELETE
  })

  const parsed = await parseResponse(response, false)

  return parsed
}
